import { UserSettingType } from "../types/user.type";
import TrackProAPI from "./track-pro-api";

const getUserSettings = () => {
  return TrackProAPI.get('/settings');
};

const updateUserSettings = (userSettings: UserSettingType) => {
  return TrackProAPI.post('/settings', userSettings)
}


// Just to simulate asynt tasks, delete if API is implemented
const timeout = (param: string) =>
  new Promise((resolve) => {
    setTimeout(() => {
      console.log(param);
      resolve("Updated");
    }, 200);
  });

const updateLanguage = (language: string) => {
  // set language
  // return TrackProAPI.post();
  return timeout(language);
};

const updateUnits = (units: string) => {
  // set language
  // return TrackProAPI.post();
  return timeout(units);
};

export default {
  updateUnits,
  updateLanguage,
  getUserSettings,
  updateUserSettings
};
